import axios from 'axios';

const API_BASE_URL = 'https://stage-apiv2.myearth.id'; // Replace with your backend base URL
//const API_BASE_URL = 'http://localhost:3030'; // Replace with your backend base URL

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// ✅ Create new template
export const createTemplate = async (data) => {
  try {
    const response = await axiosInstance.post('/templates', data);
    return response.data;
  } catch (error) {
    console.error('❌ Error creating template:', error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get all templates
export const getAllTemplates = async () => {
  try {
    const response = await axiosInstance.get('/templates');
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching all templates:', error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get templates by user ID
export const getTemplatesByUserId = async (userId) => {
  try {
    const response = await axiosInstance.get(`/templates/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`❌ Error fetching templates for user ${userId}:`, error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get template by ID
export const getTemplateById = async (id) => {
  try {
    const response = await axiosInstance.get(`/templates/${id}`);
    return response.data;
  } catch (error) {
    console.error(`❌ Error fetching template ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

// ✅ Update template by ID
export const updateTemplate = async (id, data) => {
  try {
    const response = await axiosInstance.patch(`/templates/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`❌ Error updating template ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete template by ID
export const deleteTemplate = async (id) => {
  try {
    const response = await axiosInstance.delete(`/templates/${id}`);
    return response.data;
  } catch (error) {
    console.error(`❌ Error deleting template ${id}:`, error.response?.data || error.message);
    throw error;
  }
};
